// Uses rAF + setTimeout(0) double-yield: rAF fires after layout/paint is
// scheduled, setTimeout(0) fires after the paint is actually composited.
export const yieldToPaint = () =>
  new Promise(resolve => {
    requestAnimationFrame(() => setTimeout(resolve, 0));
  });
